






















import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import PageTitle from "@/components/PageTitle";
import PromoteViewItem from "../PromoteViewItem.vue";

export interface PromoteItem {
  title: string;
  description: string;
  imgSrc: string;
  imgSrcBig: string;
}

export default defineComponent({
  name: "PromoteView",
  components: { PromoteViewItem, BaseButton, PageTitle },
  setup() {
    const promoteList: PromoteItem[] = [
      {
        title: $t("Discovery"),
        description: $t("Get discovered by top brands and monetize each engagement"),
        imgSrc: "/img/promote/discovery.png",
        imgSrcBig: "/img/promote/discovery-big.png",
      },
      {
        title: $t("Monthly subscription"),
        description: $t("Set up subscriptions to monetize from your unique audience"),
        imgSrc: "/img/promote/monthly-subscription.png",
        imgSrcBig: "/img/promote/monthly-subscription-big.png",
      },
      {
        title: $t("Paid posts"),
        description: $t("Make your posts paid with subscription or one-time buy"),
        imgSrc: "/img/promote/paid-posts.png",
        imgSrcBig: "/img/promote/paid-posts-big.png",
      },
      {
        title: $t("Paid messages"),
        description: $t("Monetize communication with your subscribers"),
        imgSrc: "/img/promote/paid-messages.png",
        imgSrcBig: "/img/promote/paid-messages-big.png",
      },
      {
        title: $t("Private audio & video calls"),
        description: $t("Give your subscribers more options to become closer to you"),
        imgSrc: "/img/promote/private-video-audio.png",
        imgSrcBig: "/img/promote/private-video-audio-big.png",
      },
    ];

    return { promoteList };
  },
});
